// extracted by mini-css-extract-plugin
module.exports = {"grid":"hero-module--grid--SDvDy","grid__item":"hero-module--grid__item--31g1q","hero__cta":"hero-module--hero__cta--8cjAf","hero__title":"hero-module--hero__title--UnZZ2"};